var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A8AC",
    fillRule: "evenodd",
    d: "M20 9C13.928 9 9 13.928 9 20s4.928 11 11 11 11-4.928 11-11S26.072 9 20 9zm-5.423 17.908c.473-.99 3.355-1.958 5.423-1.958s4.961.968 5.423 1.958A8.682 8.682 0 0 1 20 28.8a8.682 8.682 0 0 1-5.423-1.892zm12.419-1.595c-1.573-1.914-5.39-2.563-6.996-2.563-1.606 0-5.423.649-6.996 2.563A8.745 8.745 0 0 1 11.2 20c0-4.851 3.949-8.8 8.8-8.8 4.851 0 8.8 3.949 8.8 8.8a8.745 8.745 0 0 1-1.804 5.313zM20 13.4a3.84 3.84 0 0 0-3.85 3.85A3.84 3.84 0 0 0 20 21.1a3.84 3.84 0 0 0 3.85-3.85A3.84 3.84 0 0 0 20 13.4zm0 5.5c-.913 0-1.65-.737-1.65-1.65 0-.913.737-1.65 1.65-1.65.913 0 1.65.737 1.65 1.65 0 .913-.737 1.65-1.65 1.65z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit-profile.aa9b7152fdcbcee52858b5a5a6ab6b12.svg";
export { ForwardRef as ReactComponent };